<div class="content-container print-content">
  <div class="pendingheading">{{TOC_pageHeader}}</div>
  <div class="mt-2 flex-display mb-1">
    <label class="ml-8 para-content content-blue" [innerHTML]="TOC_Subdesc">
    </label>
  </div>
  <div class="mt-2 flex-display mb-1">
    <h3 class="ml-8 para-content content-blue bold" [innerHTML]="TOC_Subtitle">
    </h3>
  </div>
  <div>
    <div>
      <div *ngFor="let listdata of pdflistdata" class="help-topic-container flex-display">
        <div class="singleLine flex-display">
          <a class="highlight-blue cursor-pointer pdf-link" (contextmenu)="onRightClick($event,listdata.linkText)" (click)="Open($event,listdata.linkText)" [target]="_blank">{{listdata.title}}</a>
        </div>
      </div>
    </div>
  </div>
</div>
